export enum MortgageTypeIrt {
  annuities = 'annuitair',
  linear = 'lineair',
  interestFree = 'aflossingsvrij',
  equity = 'overwaarde',
  sustainable = 'duurzaam',
  save = 'bankspaar',
  savingsGrowth = 'spaargroei',
  start = 'startzeker',
  growthWith = 'meegroei',
  credit = 'krediet',
  other = 'overig'
}
